import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PaymentMethod, PaymentMethodType } from 'src/app/core/models';
import { SetSelectedPaymentMethodUserData } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.actions';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';
import { PaymentMethodsState } from 'src/app/core/store/payment-methods/payment-methods.state';
import { asFormControl } from 'src/app/core/utils/common';
import { validateAllFormFields } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
})
export class PaymentMethodComponent implements OnInit {
  @Input() isPaymentMethodTouched: boolean = false;
  @Output() editModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Select(PaymentMethodsState.paymentMethods) paymentMethods$!: Observable<PaymentMethod[]>;
  @Select(OrderWizardDataState.selectedPaymentMethod) selectedPaymentMethod$!: Observable<PaymentMethod | null>;

  editMode: boolean = false;
  displayModal: boolean = false;
  showErrors: boolean = false;

  paymentMethodsForm = new FormGroup({
    selectedPaymentMethodId: new FormControl(null),
  });

  initialValues = {
    selectedPaymentMethodId: null as string | null,
  };

  asFormControl = asFormControl;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.selectedPaymentMethod$.subscribe((selectedPaymentMethod) => {
      const currentSelection = this.paymentMethodsForm.value.selectedPaymentMethodId;

      if (!currentSelection) {
        this.initialValues.selectedPaymentMethodId = selectedPaymentMethod?.id || null;
        this.paymentMethodsForm.patchValue({ selectedPaymentMethodId: selectedPaymentMethod?.id || null });
      }
    });
  }

  switchToEdit() {
    this.editMode = true;
    this.editModeChange.emit(this.editMode);
  }

  endEdit() {
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }

  showModal() {
    this.displayModal = true;
  }

  hideModal() {
    this.displayModal = false;
  }

  onSubmit() {
    if (this.paymentMethodsForm.valid) {
      this.store.dispatch(new SetSelectedPaymentMethodUserData(this.paymentMethodsForm.value.selectedPaymentMethodId));
      this.endEdit();
      this.showErrors = false;
    } else {
      validateAllFormFields(this.paymentMethodsForm);
      this.showErrors = true;
    }
  }

  onCancel() {
    this.endEdit();
    this.paymentMethodsForm.setValue(this.initialValues);
    this.showErrors = false;
  }

  isPaymentMethodExpired(paymentMethod: PaymentMethod | null): boolean {
    return !!paymentMethod && paymentMethod.type === PaymentMethodType.CreditCard && paymentMethod.info.isExpired;
  }

  onPaymentMethodCreated(newPaymentMethodId: string) {
    this.switchToEdit(); // Done to handle single payment method case
    this.paymentMethodsForm.get('selectedPaymentMethodId')?.setValue(newPaymentMethodId);
  }
}
